import { getButtonIcon, isButtonIcon } from '@helpers/getButtonIcon';
import { imageUrl } from '@helpers/image';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from '../Button/Button.styles';
const LinkButton = ({ buttonSize = 'default', buttonType = 'orange-solid', children, fillDirection = 'right', icon, iconOnly, iconPosition = 'left', ...otherProps }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { as: "a", "data-fill": fillDirection, "data-icon-only": iconOnly, "data-icon-position": iconPosition, "data-size": buttonSize, "data-type": buttonType, ...otherProps },
            React.createElement(S.Text, null, children),
            icon && (React.createElement(S.IconWrapper, null, isButtonIcon(icon) ? (getButtonIcon(icon)) : (React.createElement(S.ButtonImage, { src: imageUrl(icon, {}), alt: icon.altText, loading: "lazy" })))))));
};
export default LinkButton;
